<template>
  <b-row>
    <b-col>
      <div data-test-id="AgencySelectorComponent">
        <div v-if="emsAgencies.length > 1">
          <b-form-select
            v-model="selected"
            class="selector"
            name="agency-selector"
            data-test-id="AgencySelectorItem"
            :options="options"
            @change="onSelectAgency"
          ></b-form-select>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "AgencySelector",
  props: {
    selectedEmsAgency: {
      type: Object,
      default() {
        return {};
      }
    },
    emsAgencies: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: this.selectedEmsAgency
    };
  },
  computed: {
    options() {
      return [
        { text: "Please select an EMS Agency", value: null },
        ...this.emsAgencies.map(emsAgency => ({ text: emsAgency.name, value: emsAgency }))
      ];
    }
  },
  watch: {
    selectedEmsAgency(agency) {
      if (agency) {
        this.selected = agency;
      }
    }
  },
  methods: {
    onSelectAgency(agency) {
      this.$emit("agencySelected", agency);
    }
  }
};
</script>

<style scoped lang="css">
.selector {
  max-width: 350px;
}
</style>
